<template>
  <div>
    <vs-button
      v-bind:class="{ active: $store.state.route.query.tab === 'all' }"
      color="primary"
      :type="$store.state.route.query.tab === 'all' ? 'filled' : 'line'"
      @click="handleTabClick('all')"
      class="tab-btn"
    >
      Tüm Kullanıcılar
    </vs-button>
    <vs-button
      v-bind:class="{ active: $store.state.route.query.tab === 'flagged' }"
      color="warning"
      :type="$store.state.route.query.tab === 'unapproved' ? 'filled' : 'line'"
      @click="handleTabClick('unapproved')"
      class="tab-btn"
    >
      Onaysız Kullanıcılar
    </vs-button>

    <vs-button
      v-bind:class="{ active: $store.state.route.query.tab === 'flagged' }"
      color="danger"
      :type="$store.state.route.query.tab === 'banned' ? 'filled' : 'line'"
      @click="handleTabClick('banned')"
      class="tab-btn"
    >
      Banlanan Kullanıcılar
    </vs-button>
    <user-list :list="list" />
  </div>
</template>

<script>
import UserList from '@/components/user/UserList.vue';
import { getPaginationState } from '@/utils/pagination';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  components: { UserList },
  computed: {
    ...mapGetters('user', ['list', 'pagination']),
    paginationState() {
      const pagination = getPaginationState(this.pagination, this.$store.state.route.query);
      return pagination;
    }
  },
  methods: {
    ...mapMutations('user', ['setPagination']),
    ...mapActions('user', ['getUsers']),
    async filterList(type) {
      this.$vs.loading();
      await this.getUsers(type);
      this.$vs.loading.close();
    },
    resetQueryParams() {
      const query = this.$store.state.route.query;
      delete query.search;
      delete query.tab;
    },
    handleTabClick(type) {
      this.resetQueryParams();
      const newPath = { query: { ...this.paginationState, page: 1, tab: type } };
      this.$router.push(newPath);
    }
  },
  async created() {
    const query = this.$store.state.route.query;
    if (this.$store.state.route.query.perPage) {
      this.setPagination(query);
    }
    if (query.hasOwnProperty('search') || query.hasOwnProperty('id')) {
      await this.filterList();
      return;
    } else if (!query.hasOwnProperty('tab')) {
      const newPath = { query: { ...this.paginationState, page: 1, tab: 'all' } };
      this.$router.replace(newPath);
    } else {
      await this.filterList(query.tab);
    }
  }
};
</script>

<style>
.tab-btn + .tab-btn {
  margin: 5px;
}
</style>
